<div class="p-a-xl">
    <h2>Cipo Number Fields</h2>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        @for (control of form().controls | keyvalue; track $index) {
            <div fxFlex="30" fxFlexAlign="start" class="m-t">
                <cipo-number [control]="control.value" />
            </div>
        }
    </div>

    <hr />
    Last value changed as invariant number:
    <pre>{{ lastValue() || " " }}</pre>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        <button mat-raised-button (click)="markAsTouched(true)">Mark all controls as touched</button>
        <button mat-raised-button (click)="markAsTouched(false)">Mark all controls as untouched</button>
    </div>
</div>
